(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wb-advanced-selling-points"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wb-advanced-sale-points')) {
    customElements.define('wb-advanced-sale-points', class extends HTMLElement {
      connectedCallback() {
        if (this.wbSaleReady) return;
        this.wbSaleReady = true;
        const clear = () => {
          this.querySelectorAll('.wb-advanced-sale__button').forEach(button => button.setAttribute('aria-pressed', 'false'));
        };
        this.addEventListener('pointerdown', event => {
          this.wbPointer = event.pointerType;
          this.toggleAttribute('data-touch', event.pointerType !== 'mouse');
        });
        this.addEventListener('pointerover', event => {
          if (event.pointerType === 'mouse') {
            this.removeAttribute('data-touch');
            clear();
          }
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('.wb-advanced-sale__button');
          if (!button || !this.contains(button)) return;
          if (this.wbPointer === 'mouse' && event.detail !== 0) return;
          const selected = button.getAttribute('aria-pressed') !== 'true';
          clear();
          button.setAttribute('aria-pressed', String(selected));
        });
        this.addEventListener('keydown', event => { if (event.key === 'Escape') clear(); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
